module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmarks-fill-3fc64bf8.svg";